export const AccidentType =
{
    RearEndCollision: 1,
    SideSwipe: 2,
    HeadOnCollision: 3,
    SideImpactCrash: 4,
    MultiVehicleCollision: 5,
    RollOverAccident: 6,
    SingleVehicleCrash: 7
};

export const ApprovalStatus =
{
    Approved: 0,
    Pending: 1,
    Declined: 2,
    Cancelled: 3,
    Paid: 4
}

